import { render, staticRenderFns } from "./DetailsModal.vue?vue&type=template&id=a8d9ab72&"
import script from "./DetailsModal.vue?vue&type=script&lang=js&"
export * from "./DetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./DetailsModal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports